import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import CampaignStatusBadge from "./CampaignStatusBadge";
import CampaignOriginCell from "./CampaignOriginCell";
import CampaignErrorsCell from "./CampaignErrorsCell";
import CampaignListRowActions from "./CampaignListRowActions";
import CampaignZoneCell from "./CampaignZoneCell";
import { getCampaignZoneDisplay } from "../hooks/useCampaignListData";

const formatDate = (date) => {
  if (!date) return "-";
  const d = new Date(date);
  return d.toLocaleDateString("fr-FR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
};

const CampaignListRow = ({ campaign, onEdit, onDuplicate, onDelete }) => {
  const history = useHistory();
  const { t } = useTranslation();

  const periodLabel = `${formatDate(campaign.start)} au ${formatDate(campaign.stop)}`;
  const zoneDisplay = getCampaignZoneDisplay(campaign);

  const handleRowClick = (event) => {
    if (
      event.target.closest(".table-standard-row-actions") ||
      event.target.closest(".table-standard-row-actions-dots") ||
      event.target.closest(".action-choice")
    ) {
      return;
    }
    history.push(`/campaign/${campaign._id}`, { campaign });
  };

  return (
    <div className="table-standard-row cursor-pointer" onClick={handleRowClick}>
      <div className="table-standard-row-cell" data-label={t("Waste origin")}>
        <CampaignOriginCell
          name={campaign.addressName}
          city={campaign.addressCity}
        />
      </div>
      <div className="table-standard-row-cell" data-label={t("Zone")}>
        <CampaignZoneCell
          zoneLabel={campaign.zoneLabel || zoneDisplay.zoneLabel}
          flowLabel={campaign.flowLabel || zoneDisplay.flowLabel}
        />
      </div>
      <div className="table-standard-row-cell" data-label={t("Campaign date")}>
        <span className="table-standard-row-cell-truncate text-sm leading-[22px]">
          {periodLabel}
        </span>
      </div>
      <div className="table-standard-row-cell" data-label={t("Status")}>
        <CampaignStatusBadge status={campaign.status} />
      </div>
      <div
        className="table-standard-row-cell"
        data-label={t("campaign.sortingErrorsTreated")}
      >
        <CampaignErrorsCell
          status={campaign.status}
          stop={campaign.stop}
          totalTreated={campaign.totalTreated}
          treatmentPercent={campaign.treatmentPercent}
          progressionPercent={campaign.progressionPercent}
        />
      </div>
      <CampaignListRowActions
        onEdit={() => onEdit(campaign)}
        onDuplicate={() => onDuplicate(campaign)}
        onDelete={() => onDelete(campaign)}
      />
    </div>
  );
};

export default CampaignListRow;
